import getControlsInactive from "selectors/getControlsInactive";
import getHasSubchapter from "selectors/getHasSubchapter";
import getShowSlideshowGallery from "selectors/getShowSlideshowGallery";
import getUseInactivity from "selectors/getUseInactivity";
import { createSelector } from "reselect";

const getIsChapterCoverShowing = (state) => state.forceChapterCover;
const getIsStoryCoverShowing = (state) =>
  !state.route.params.chapterKey && !state.playerOptions.singleVideoPlayer;
const getIsAdPlaying = (state) => state.ads.adPlaying;

export const getShowControls = createSelector(
  [
    getControlsInactive,
    getHasSubchapter,
    getIsAdPlaying,
    getIsChapterCoverShowing,
    getIsStoryCoverShowing,
    getShowSlideshowGallery,
    getUseInactivity,
  ],
  (
    controlsInactive,
    hasSubchapter,
    isAdPlaying,
    isChapterCoverShowing,
    isStoryCoverShowing,
    showSlideshowGallery,
    useInactivity,
  ) => {
    let hideControls = false;

    if (useInactivity) {
      if (isStoryCoverShowing) {
        hideControls = !isAdPlaying;
      } else if (isChapterCoverShowing) {
        hideControls = hasSubchapter;
      } else {
        hideControls = hasSubchapter || controlsInactive;
      }
    } else {
      hideControls = hasSubchapter || showSlideshowGallery;
    }

    return !hideControls;
  },
);

export default getShowControls;
